import $ from 'jquery'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class ShareLinkPopover extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    tip: PropTypes.string
  }

  componentDidMount() {
    Qualvu.InitializeVtipClick($(findDOMNode(this)))
  }

  render() {
    const { children, tip } = this.props

    return (
      <div>
        <div className="vtip_click" data-vtip={tip}>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/ShareLinkPopover.js